<template>
  <div class="container">
    <div class="body">
      <v-text-field
        autofocus
        filled
        background-color="textBoxBackground"
        label="Name"
        style="height: 66px"
        v-model="userEditObj.name"
        @keyup.enter="$emit('request-save')"></v-text-field>
      <v-textarea
        filled
        height="400"
        no-resize
        background-color="textBoxBackground"
        label="Description"
        v-model="userEditObj.description"></v-textarea>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps(['userEditObj']);
</script>

<style scoped></style>
